import { useEffect, useRef } from "react";
import { subscribeRealtime } from "./client";
import type { RealtimeSignal } from "./client";
import type { RealtimeModule } from "./protocol";

export function useRealtime(module: RealtimeModule, listener: (signal: RealtimeSignal) => void) {
  const listenerRef = useRef(listener);
  useEffect(() => {
    listenerRef.current = listener;
  }, [listener]);
  useEffect(
    () => subscribeRealtime(module, signal => listenerRef.current(signal)),
    [module],
  );
}
